import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';
import { permissionSchema } from '@/api/schemas/permission-schema';

export const facilitySchema = new schema.Entity(EntityTypes.Facility, {
  permissions: [permissionSchema],
});
